import api from '@/lib/axios'

export interface TokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
}

export interface UserResponse {
  id: string
  email: string
  full_name: string | null
  is_active: boolean
  is_superadmin: boolean
  created_at: string
}

export interface UserOrgResponse {
  org_id: string
  org_name: string
  org_slug: string
  role: string
  is_current: boolean
}

export const authApi = {
  register: (data: { email: string; password: string; full_name: string }) =>
    api.post<TokenResponse>('/auth/register', data).then((r) => r.data),

  login: (data: { email: string; password: string }) =>
    api.post<TokenResponse>('/auth/login', data).then((r) => r.data),

  refresh: (refresh_token: string) =>
    api.post<TokenResponse>('/auth/refresh', { refresh_token }).then((r) => r.data),

  switchOrg: (target_org_id: string) =>
    api.post<TokenResponse>('/auth/switch-org', { target_org_id }).then((r) => r.data),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }).then((r) => r.data),

  getMe: () => api.get<UserResponse>('/auth/me').then((r) => r.data),

  getMyOrgs: () => api.get<UserOrgResponse[]>('/users/me/orgs').then((r) => r.data),
}
